/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export const useSelectItemCatalogueStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
  },
  title: {
    margin: '0 14px 5px',
  },
  list: {},
  noOptionsText: {
    color: theme.palette.text.primary,
    fontSize: '12px',
    lineHeight: '15px',
  },
}));
